import React from 'react';
import Accordion from '../../accordion';
import Icon from '~/components/icon';
import Link from '../../link';
import styles from '../style/sports-list.module.css';
import type INavData from '../../../interfaces/config/nav';

interface IProps {
  navData: INavData;
}

const SportsList: React.FC<IProps> = ({ navData }) => {
  const [activeAccordion, setActiveAccordion] = React.useState('');

  const allSports = navData.allSports;

  const renderSubCategories = (subCategories) => {
    if (!subCategories) {
      return null;
    }
    return (
      <div className={styles.accordionBody} data-testid="sub-categories">
				{subCategories.map((category, index) =>
        <Link key={index} className={styles.category} to={category.url}>
						<Icon icon={category.icon} /> {category.text}
					</Link>
        )}
			</div>);

  };

  const getIcon = (iconString) => {
    if (!iconString) return null;

    const [icon, dimension = '24'] = iconString.split(',');

    return (
      <Icon
        icon={icon}
        height={parseInt(dimension, 10)}
        width={parseInt(dimension, 10)} />);


  };

  return (
    <div className={styles.sportsList}>
			{allSports.map((sport, index) =>
      <div data-testid="sport" key={index} className={styles.accordion}>
					<Accordion
          key={sport.text}
          isActive={activeAccordion === sport.text}
          header={
          <Link to={sport.url} className={styles.accordionHeader}>
								{getIcon(sport.icon)} {sport.text}
							</Link>
          }
          body={renderSubCategories(sport.subCategories)}
          callback={() => setActiveAccordion(sport.text)} />

				</div>
      )}
		</div>);

};

export default SportsList;